<template>
  <ul 
    :class="options.css_classes" 
    class="checkbox-group"
    style="margin-left: 0">
    <li 
      v-for="(item, index) in options.source" 
      :key="index">
      <label>
        <input 
          type="checkbox" 
          :value="item.value" 
          :name="'field-' + options.id" 
          v-model="selected_values"
          @change="change" 
          class="checkbox" />
        {{ item.label }}
      </label>
    </li>
  </ul>
</template>

<script>
export default { 
  name: 'CheckboxGroup',
  props: {
    options: {
      type: Object,
      required: true
    },
    value: {
      type: Array
    }
  },
  data () {
    return {
      selected_values: []
    }
  },
  methods: {
    change () {
      this.$commit.setFieldValue({
        key: 'field-' + this.options.id, 
        value: this.selected_values
      })
    },
    validate () {
      return (this.value.length !== 0)
    }
  },
  computed: {
    isValid () {
      if (this.value.length !== 0) {
        return true
      }
      return false
    }
  },
  mounted () {
    this.selected_values = (this.value === Array ? this.value : [])
  }
}
  
</script>
